import _get from 'lodash/get';

// this object has filters in the same order as filtersOrder.js
// this maps the filtersValues key to the path in the showcaseListing object
// add commented out fields to alpha endpoint?
const filterToListingCriteriaMap = {
    startYear: 'year',
    endYear: 'year',
    makeCode: 'makeCode',
    modelCode: 'modelCode',
    trimCode: 'trim',
    listingType: 'listingType',
    driveGroup: 'driveType',
    minPrice: 'pricingDetail',
    maxPrice: 'pricingDetail',
    mileage: 'mileage.value',
    vehicleStyleCode: 'bodyStyles[0].code',
    // vehicleSubTypes
    fuelTypeGroup: 'fuelType',
    mpgRange: 'mpgHighway',
    extColorSimple: 'color.exteriorColorSimple',
    intColorSimple: 'color.interiorColorSimple',
    // transmissionCode: 'transmissionCode',
    // engineDisplacement: 'engineDisplacement',
    // vehicleHistoryType: 'productTiles',
    // homeServices: 'homeServices',
    engineCode: 'engine.code',
    // features: 'features',
    doorCode: 'doors',
};

const rangeCriteria = [
    'endYear',
    'startYear',
    'minPrice',
    'maxPrice',
    'mileage',
    'mpgRange',
    // ev range
];

function translateFilterChipValues({ filterChips = [] }) {
    const translatedCriteria = [];
    filterChips.forEach((chip) => {
        const simplifiedKey = chip?.filterName?.split('|')[0];
        const mappedKey = filterToListingCriteriaMap[simplifiedKey];
        const listValue = Array.isArray(chip.value) ? chip.value : [chip.value];

        if (mappedKey) {
            translatedCriteria.push({
                ...chip,
                characterCount: chip?.label?.length || 0,
                filterName: mappedKey,
                isRange: rangeCriteria.includes(simplifiedKey),
                value: listValue,
            });
        }
    });
    return translatedCriteria;
}

const handleMinAndMaxRange = ({ chip, filterKeyMin, filterKeyMax, filtersValues, listingSpec, missingCriteria }) => {
    if ((filtersValues[filterKeyMin] && listingSpec < parseInt(filtersValues[filterKeyMin], 10))
        || (filtersValues[filterKeyMax] && listingSpec > parseInt(filtersValues[filterKeyMax], 10))) {
        missingCriteria.push(chip);
    }
};

// handle comparing range filters to the showcase listing object
const handleRangeCriteria = ({ chip, filtersValues, listingSpec, missingCriteria }) => {
    if (chip.filterName === 'mpgHighway') {
        const mpgValue = _get(filtersValues, 'mpgRange[0]', '0').split('-')[0];
        const mpgNum = mpgValue && parseInt(mpgValue, 10);

        if (listingSpec < mpgNum) {
            missingCriteria.push(chip);
        }
    } else if (chip.filterName.includes('mileage')) {
        const mileageValue = typeof listingSpec === 'string' ? listingSpec.replaceAll(',', '') : 0;
        const alphaMileage = parseInt(mileageValue, 10);
        const filterMileage = parseInt(chip.value, 10);

        if (alphaMileage > filterMileage) {
            missingCriteria.push(chip);
        }
    } else if (chip.filterName.includes('year')) {
        handleMinAndMaxRange({
            chip, filterKeyMin: 'startYear', filterKeyMax: 'endYear', filtersValues, listingSpec, missingCriteria });
    } else if (chip.filterName.includes('pricing')) {

        const alphaPricing = listingSpec?.incentive || listingSpec?.salePrice || listingSpec?.msrp;
        const alphaPrice = Number.isInteger(alphaPricing) ? alphaPricing : 0;

        handleMinAndMaxRange({
            chip, filterKeyMin: 'minPrice', filterKeyMax: 'maxPrice', filtersValues, listingSpec: alphaPrice, missingCriteria });
    }
};

// for each filter selected, create an array of filter chips that represent what filter criteria is not part of the
// showcase listing
const getMissingCriteria = ({ filtersValues = {}, translatedCriteria = [], showcaseListing = {} }) => {
    const missingCriteria = [];

    translatedCriteria.forEach((chip) => {
        const listingSpec = _get(showcaseListing, chip.filterName);

        if (listingSpec && chip.isRange) {
            handleRangeCriteria({ chip, filtersValues, listingSpec, missingCriteria });
        } else if (listingSpec && !chip?.value.includes(listingSpec)) {
            missingCriteria.push(chip);
        }
    });

    return missingCriteria;
};

/**
 * @param deviceSize
 * @param filterChips
 * @param filtersValues
 * @param showcaseListing
 * @returns {{isExactMatch: boolean, missingCriteria: *[]}}
 */
export function getAlphaCriteriaMatches({
    filterChips = [],
    filtersValues = {},
    showcaseListing = {},
}) {

    if (showcaseListing && filterChips.length > 0 && Object.keys(showcaseListing).length > 0) {
        const filterChipsCopy = [...filterChips];

        const translatedCriteria = translateFilterChipValues({ filterChips: filterChipsCopy });
        const missingCriteria = getMissingCriteria({ filtersValues, translatedCriteria, showcaseListing });
        const missingCriteriaList = missingCriteria.map((criteria) => criteria.label);

        return { isExactMatch: missingCriteria.length === 0, missingCriteria: missingCriteriaList };
    }
    return { isExactMatch: true, missingCriteria: [] };
}

export default getAlphaCriteriaMatches;
